import * as $ from 'jquery';
import 'bootstrap';
import { memberPortal } from "../member-portal";
import { bookingFormCommon } from "../c005-bookingform-common";
import * as numeral from 'numeral';
import { adobeDataLayerWrapper } from "../adobeDataLayerMethod";

export class memberRedeemMHgiftcard {
	private partnerRdmForm: any = $('.members--redeem--mhgiftcard #mhgiftcard-redeem-form');
	private bookingformcommon = new bookingFormCommon();
	private memberBase: any = new memberPortal();
	$instance: any;
	private voucherList: any;
	private selectedDenomination: any;
	private selectedVoucher: any;
	private eligibilityFlag: any;
	private initialBal: any;
	private totalVoucherRedeemed: any;
	private incrementDisplayValue:any = 0;
	private countryDtls:any;
	private recipientID: any = null;
	private occasion: any='';
	private giftMessage: any = '';

	initVouchersAndUsers(): any {
		let _self = this;
		var max_voucher_count = $(".mhgiftcard-description input:hidden[class='max_voucher_count']").val();
		$(".incrementer--mhgiftcard-qty").attr("data-max", max_voucher_count);

		//prepare data for eligibility API
		let defer = $.Deferred();
		var queryString = location.search.substring(1);
		var a = queryString.split("&");
		var selectedCountry = a[0];
		let type="POST";
		let url = "/bin/services/new/mhgiftcardvoucherdetails";
		var data:any;

		if (window.location.hostname === 'localhost' && window.location.port == '5000') {
			type = "GET";
			url = '/dummy-data/mhgiftcard.json';
			data = {};
		}else{	
			let cookieAccessToken = _self.getCookie("sapphire");
			var decodedToken = parseJwt(cookieAccessToken);
			let redeemCampaignId  = $(".mhgiftcard-description input:hidden[class='campaignId']").val();
			let shoppingcartId  = $(".mhgiftcard-description input:hidden#shoppingCartID").val();
			let voucherCategory  = $(".mhgiftcard-description input:hidden[class='voucherCategory']").val();
			data = {
				'enrichId': decodedToken.extension_flyerid,
				'campaignID': redeemCampaignId,
				'shoppingcartId': shoppingcartId,
				'voucherCategory':voucherCategory,
				'selectedCountry':selectedCountry,
			};
		}


		_self.bookingformcommon.preloader();
		$.ajax({
			type: type,
			url: url,
			data: data,

			success: function (data: any) {
				let json: any = null;
				if (typeof data === 'string') {
					json = JSON.parse(data);
				} else {
					json = data;
				}
				_self.eligibilityFlag = json.eligibleFlag;
				_self.initialBal = json.currentBalance;
				_self.totalVoucherRedeemed = parseInt(json.totalVouchersRedeemed);
				_self.voucherList = json.voucherList;
				_self.selectedVoucher = _self.voucherList[0];
				_self.selectedDenomination = _self.selectedVoucher.AwardKey;
				_self.countryDtls=json.voucherCountryDtls;
				
				let currentBalance = _self.partnerRdmForm.find('#mhgiftcard-current-balance');
				
				_self.initDenominations();


				$(".voucherEligibity").removeClass("showclass").addClass("hideclass");
				$(".overwhelming_resp").removeClass("showclass").addClass("hideclass");
				$(".maxcount_reached_onload").removeClass("showclass").addClass("hideclass");
				$(".maxcount_reached_onclick").removeClass("showclass").addClass("hideclass");
				$(".redeem-mhgiftcard").removeClass("hideclass").addClass("showclass");//DISPLAY
				$(".mhgiftcard-redemption").removeClass("hideclass").addClass("showclass");//DISPLAY
				
				$(".successMsg").removeClass("showclass").addClass("hideclass");
				$(".errorMsg").removeClass("showclass").addClass("hideclass");

				$(".btn-member--submit").addClass("disabled");
				if (_self.eligibilityFlag == "true") {


					if (parseInt(_self.initialBal) <= 0) {
						$(".voucherEligibity").removeClass("hideclass").addClass("showclass"); //DISPLAY
					}

					if (_self.selectedVoucher) {
						let voucherCountVal = parseInt(_self.selectedVoucher["AwardCount"]);
						if (voucherCountVal == 0) {
							if (!$("#mhgiftcard-qty--increment").hasClass("disabled")) {
								$("#mhgiftcard-qty--increment").addClass("disabled");
							}
						}
					}

					for(let i=1;i<=_self.countryDtls.length;i++){
						$("#selected-country").html(_self.countryDtls[i-1].country);
						$(".mhgiftcard-description input:hidden[class='currencyValue']").val(_self.countryDtls[i-1].countryCode);
					}

					$("#displayClass").removeClass("hideclass").addClass("showclass");

					currentBalance.html(json.currentBalance);
					_self.getVoucherTypeValues(_self.initialBal, _self.voucherList, _self.totalVoucherRedeemed, max_voucher_count);
				}
				else if (_self.eligibilityFlag == "false") {
					currentBalance.html(json.currentBalance);

					$(".overwhelming_resp").removeClass("hideclass").addClass("showclass"); //DISPLAY
					$("#displayClass").removeClass("hideclass").addClass("showclass");

					$("#mhgiftcard-qty--increment").addClass("disabled");


				} else if (_self.eligibilityFlag == "DateError") {

					$(".date_expire").removeClass("hideclass").addClass("showclass");//DISPLAY

					$("#displayClass").removeClass("hideclass").addClass("showclass");

					$("#mhgiftcard-qty--increment").addClass("disabled");

				} else {

					$(".redeem-mhgiftcard").removeClass("showclass"); //DISPLAY
					$(".redeem-mhgiftcard").addClass("hideclass"); //DISPLAY
					$(".mhgiftcard-redemption").removeClass("showclass");
					$(".mhgiftcard-redemption").addClass("hideclass");
					$(".partner-redem-incrementer").removeClass("showclass");
					$(".partner-redem-incrementer").addClass("hideclass");
					$(".onload_errorMsg").removeClass("hideclass");//DISPLAY
					$(".onload_errorMsg").addClass("showclass");//DISPLAY
				}
				_self.bookingformcommon.preloaderClose();
				defer.resolve(json);
			}, error: function (error: any) {

				_self.bookingformcommon.preloaderClose();
				defer.reject(error);
			}
		});
		return defer.promise();
	}
	initMhInputs():any{
		let _self = this;
		let inputErefftect: any = $.makeArray(_self.partnerRdmForm.find('textarea'));
		_self.memberBase.initFormTextInputs(inputErefftect);
		let inputElArr: any = $.makeArray(_self.partnerRdmForm.find('.incrementer'));
		_self.setIntialIncreamentVal(inputElArr);
	}
	setIntialIncreamentVal(inputElArr: any): any {
		let _self = this
		for (var i = 0, len = inputElArr.length; i < len; i++) {
			let el = $(inputElArr[i]);
			let btnMinus = el.find('.incrementer__btn.incrementer--decrement');
			let btnPlus = el.find('.incrementer__btn.incrementer--increment');
			let elDisplay = el.find('.incrementer__display');
			let input = el.find('input[type="hidden"]');

			let params = {
				'min': parseInt(el[0].dataset.min),
				'max': parseInt(el[0].dataset.max),
				'initvalue': parseInt(el[0].dataset.initValue)
			};
			// btnMinus click handler
			// - on click, increment display value & input[hidden] value
			btnMinus.on('click', function (e: any) {
				e.preventDefault();
				e.stopPropagation();
				if ("vibrate" in navigator) {
					// vibration API supported
					navigator.vibrate(25);
				}
				_self.incrementDisplayValue = setIncrementer(elDisplay, input, _self.incrementDisplayValue, params, 'decrement');
				//alert("on decrement>>"+curVal);
			});

			// btnMinus click hold handler
			// - on hold down click,
			//   automatically decrement by 1 unit per 100ms
			//   until mouseout
			let btnMinInterval: any;

			btnMinus.on('mousedown', function (e: any) {
				e.preventDefault();
				e.stopPropagation();

				btnMinInterval = setInterval(function () {
					_self.incrementDisplayValue = setIncrementer(elDisplay, input,  _self.incrementDisplayValue, params, 'decrement');
				}, 200);
			}).on('mouseup mouseleave', function () {
				clearInterval(btnMinInterval);
			});

			// btnPlus click handler
			// - on click, increment display value & input[hidden] value
			btnPlus.on('click', function (e: any) {
				e.preventDefault();
				e.stopPropagation();

				if ("vibrate" in navigator) {
					// vibration API supported
					navigator.vibrate(35);
				}
				_self.incrementDisplayValue = setIncrementer(elDisplay, input,  _self.incrementDisplayValue, params, 'increment');
				//alert("on increment>>"+curVal);
			});

			// btnPlus click hold handler
			// - on hold down click,
			//   automatically decrement by 1 unit per 100ms
			//   until mouseout
			let btnPlusInterval: any;
			btnPlus.on('mousedown', function (e: any) {
				e.preventDefault();
				e.stopPropagation();

				// set initial delay (500ms)
				btnPlusInterval = setInterval(function () {
					_self.incrementDisplayValue = setIncrementer(elDisplay, input,  _self.incrementDisplayValue, params, 'increment');
				}, 200);
			}).on('mouseup mouseleave', function () {
				clearInterval(btnPlusInterval);
			});

		}


	}
	handleIncrement(): any {
		let _self = this;
		let totalInput = _self.partnerRdmForm.find('#mhgiftcard--voucher-total');
		let incrementerInput = _self.partnerRdmForm.find('.mhgiftcard-partner-redeem--voucher-to-use');

		// when incrementer value changes
		incrementerInput.on('incrementer.changed', function (e: any, val: any) {


			let voucherTotMiles;
			let totMilesValue = 0;
			let currentBalVal = 0;
			let voucherUnitCount = 0;
			let totVoucherRedemed = 0;
			let redeemBalValues = 0;
			let totVal = 0;
			let redeemBalance = _self.partnerRdmForm.find('#mhgiftcard-current-balance').text();
			let selectedVoucherCount
			let selectedVoucherUnits;
			let selectedVoucherValue;
			
			var max_voucher_count_on_inc = $(".mhgiftcard-description input:hidden[class='max_voucher_count']").val();

			var eligibilityFlag = _self.eligibilityFlag;
			totVoucherRedemed = parseInt(_self.totalVoucherRedeemed);
			let voucherListIncr = _self.voucherList;
			if (eligibilityFlag == "true") {
				
					let inputCount = _self.partnerRdmForm.find('#mhgiftcard-qtyinput').val();
					if (inputCount != "") {
						voucherUnitCount = selectedVoucherUnits = parseInt(inputCount);
						selectedVoucherValue = parseInt(_self.selectedVoucher.AwardValue);
						selectedVoucherCount = parseInt(_self.selectedVoucher.AwardCount);

					}
				
				if (totVoucherRedemed > 0) {
					voucherUnitCount = totVoucherRedemed + voucherUnitCount;
				} else {
					voucherUnitCount = voucherUnitCount - totVoucherRedemed;
				}

				if (voucherUnitCount <= parseInt(max_voucher_count_on_inc)) {
					if (selectedVoucherUnits <= selectedVoucherCount) {
						if (selectedVoucherValue > 0) {
							voucherTotMiles = selectedVoucherUnits * selectedVoucherValue;
						}
					}

					totMilesValue = voucherTotMiles;
					totalInput.val(totMilesValue);
					
					redeemBalValues = parseInt(redeemBalance);
					totVal = parseInt(totalInput.val());
					currentBalVal = redeemBalValues - totVal;
					_self.getVoucherTypeValues(currentBalVal, voucherListIncr, voucherUnitCount, max_voucher_count_on_inc);
					
					if (totVal > 0) {
						if($('#redemption--miles-terms-and-conditions').is(':checked')){
							$(".btn-member--submit").removeClass("disabled");
						}
						
					} else {
						$(".btn-member--submit").addClass("disabled");
					}

				}
			} else {
				if (!$("#mhgiftcard-qty--increment").hasClass("disabled")) {
					$("#mhgiftcard-qty--increment").addClass("disabled");
				}
			}

		});
	}
	getVoucherTypeValues(curBalance: any, voucherList: any, totalVoucherRedeemed: any, max_voucher_count: any): any {
		let _self = this;
		let selectedVoucherKey: any;
		let selectedVoucherCode: any;
		let selectedVoucherCount = 0;
		let selectedVoucherValue = 0;
		let selectedVoucherUnits = 0;
		let totalCountVouchers = 0;
		let onLoadVoucherCount = 0;

		let inputCount = _self.partnerRdmForm.find('#mhgiftcard-qtyinput').val();

		if (voucherList != null && voucherList.length > 0) {
			if (inputCount != "") {
				onLoadVoucherCount = parseInt(inputCount);
				totalCountVouchers = totalCountVouchers + onLoadVoucherCount;
			}
			selectedVoucherKey = _self.selectedVoucher.AwardKey;
			selectedVoucherValue = parseInt(_self.selectedVoucher.AwardValue);
			selectedVoucherCount = parseInt(_self.selectedVoucher.AwardCount);
			if (inputCount != "") {
				selectedVoucherUnits = parseInt(inputCount);
			}
			if (selectedVoucherCount >= parseInt(max_voucher_count)) {
				selectedVoucherCount = parseInt(max_voucher_count)
			}

			if (totalVoucherRedeemed < parseInt(max_voucher_count)) {
				if (curBalance >= _self.voucherList[0].AwardValue) {

					if (selectedVoucherValue > 0) {
						if (curBalance >= selectedVoucherValue) {
							if (selectedVoucherUnits < selectedVoucherCount) {
								if ($("#mhgiftcard-qty--increment").hasClass("disabled")) {
									$("#mhgiftcard-qty--increment").removeClass("disabled");
								}
								$(".maxcount_reached_onclick").removeClass("showclass").addClass("hideclass");
								$(".rmMaxErrorMsg4").removeClass("showclass");
								$(".rmMaxErrorMsg4").addClass("hideclass");
							} else {
								if (!$("#mhgiftcard-qty--increment").hasClass("disabled")) {
									$("#mhgiftcard-qty--increment").addClass("disabled");
								}

								$(".rmMaxErrorMsg4").removeClass("hideclass");
								$(".rmMaxErrorMsg4").addClass("showclass");
							}
						} else {
							if (!$("#mhgiftcard-qty--increment").hasClass("disabled")) {
								$("#mhgiftcard-qty--increment").addClass("disabled");
							}
						}
						if(selectedVoucherUnits<=0){
							if (!$("#mhgiftcard-qty--decrement").hasClass("disabled")) {
								$("#mhgiftcard-qty--decrement").addClass("disabled");
							}
						}else{
							if ($("#mhgiftcard-qty--decrement").hasClass("disabled")) {
								$("#mhgiftcard-qty--decrement").removeClass("disabled");
							}
						}
					}

					$('.mhgiftcard-redeem-error-validations').children('p').removeClass("showclass").addClass("hideclass");
				} else {
					$("#mhgiftcard-qty--increment").addClass("disabled");
					$(".successMsg").removeClass("showclass").addClass("hideclass");
					$(".errorMsg").removeClass("showclass").addClass("hideclass");
					$(".redeem-mhgiftcard").removeClass("hideclass").addClass("showclass");
					$('.mhgiftcard-redeem-error-validations').children('p').removeClass("showclass").addClass("hideclass");

					if (totalCountVouchers <= 0) {
						$(".voucherEligibity").removeClass("hideclass");
						$(".voucherEligibity").addClass("showclass");
					}

					$(".btn-member--submit").addClass("disabled");
				}
			} else {
				if (!$("#mhgiftcard-qty--increment").hasClass("disabled")) {
					$("#mhgiftcard-qty--increment").addClass("disabled");
				}

				$(".successMsg").removeClass("showclass").addClass("hideclass");
				$(".errorMsg").removeClass("showclass").addClass("hideclass");
				$(".redeem-mhgiftcard").removeClass("hideclass").addClass("showclass");

				$(".rmMaxErrorMsg4").removeClass("showclass").addClass("hideclass");

				if (totalCountVouchers <= 0) {
					$(".maxcount_reached_onload").removeClass("hideclass").addClass("showclass"); //DISPLAY
					$(".maxcount_reached_onclick").removeClass("showclass").addClass("hideclass");
				} else {
					$(".maxcount_reached_onclick").removeClass("hideclass").addClass("showclass"); //DISPLAY
					$(".maxcount_reached_onload").removeClass("showclass").addClass("hideclass");
				}
				$(".voucherEligibity").removeClass("showclass").addClass("hideclass");
				$(".overwhelming_resp").removeClass("showclass").addClass("hideclass");

				$(".btn-member--submit").addClass("disabled");
			}

		} else {
			$(".redeem-mhgiftcard").removeClass("hideclass").addClass("showclass"); //DISPLAY
			$('.mhgiftcard-redeem-error-validations').children('p').removeClass("showclass").addClass("hideclass");
			$(".voucherEligibity").removeClass("hideclass").addClass("showclass"); //DISPLAY

			$(".mhgiftcard-partner-redeem--voucher-to-use").removeClass("showclass").addClass("hideclass");
			$(".voucher-points-to-use").removeClass("showclass");
			$(".voucher-points-to-use").addClass("hideclass");
			$(".mhgiftcard-redemption").removeClass("showclass");
			$(".mhgiftcard-redemption").addClass("hideclass");
			$(".partner-redem-incrementer").removeClass("showclass");
			$(".partner-redem-incrementer").addClass("hideclass");
		}
	}

	initDenominations():any{
		let _self = this;
			let dynamicListHtml = '';
			for(var i = 0; i <_self.voucherList.length; i++){
				if(i==0){
					dynamicListHtml+=`<li class="active">${_self.voucherList[i].AwardKey}</li>`;
				}else{
				dynamicListHtml+=`<li>${_self.voucherList[i].AwardKey}</li>`;
				}
			}
			let finalHtml = `<div class="col-xs-12 col-sm-6" id="mhgiftcard-denomination"><span class="label">Denominations:</span>
			  <ul class="voucher-denominations">`
				+ dynamicListHtml +
			  `</ul>
			</div>`;
		  let elm = $('#mhgiftcard-denominations-container').find('div.row.mhgift-card-incrementer');
		  elm.html(finalHtml);
		  _self.handleDenominationChange();		
		_self.handleTermsConditions();
	}
	handleDenominationChange(): any {
		let _self = this;
		$('#mhgiftcard-denomination .voucher-denominations li').click(function () {
			$('.voucher-denominations li').removeClass('active');
			$(this).addClass('active');
		 	_self.selectedDenomination = $(this).text().trim();
			_self.selectedVoucher = _self.voucherList.find((item: any) => item.AwardKey == _self.selectedDenomination);
			let display = $('#mhgiftcard-qty').find('.incrementer__display');
			let input = $('#mhgiftcard-qty').find('input[type="hidden"]');
			_self.incrementDisplayValue = setIncrementer(display,input,0,{},'');
			
			
		})
	}
	checkEnrichId(): any {
        let _self = this;
        $("#check-btn").click(function () {
			$(".mhgiftcard-msg").removeClass("showclass").addClass("hideclass");
			_self.recipientID = '';
            let url = '/bin/services/new/enrichIdValidator';
            let data = { enrichID: $('#mhgiftcard-recipient-id').val() };
            _self.bookingformcommon.preloader();
            $.ajax({
                type: 'POST',
                url: url, 
                data: data,
                success: function (data: any) {
                    _self.bookingformcommon.preloaderClose();
                    //var json = JSON.parse(data);
                    let json: any = null;
                    if (typeof data === 'string') {
                        json = JSON.parse(data);
                    } else {
                        json = data;
                    }
					$("#mhgiftcard-recipient").find(".success-msg").removeClass("hideclass").addClass('showclass');
					$(this).addClass("verified");
					$("#recipient-enrich-email").text(json.emailId);
					if($('#redemption--miles-terms-and-conditions').is(':checked') && parseInt(_self.partnerRdmForm.find('#mhgiftcard--voucher-total').val())>0){
						$(".btn-member--submit").removeClass("disabled");
					}

                }, error: function (error: any) {
					console.log(error.responseText);
					$(".btn-member--submit").addClass("disabled");
					let response: any = null;

					try{
						response = JSON.parse(error.responseText);

						if(response.status===404){
							$("#mhgiftcard-recipient").find(".error-msg").removeClass("hideclass").addClass('showclass');
						}else if(response.status===400){
							$("#mhgiftcard-recipient").find(".general-error-msg").removeClass("hideclass").addClass('showclass');
						}
						else{
							$("#mhgiftcard-recipient").find(".general-error-msg").removeClass("hideclass").addClass('showclass');
						}
					}
					catch(e){
						$("#mhgiftcard-recipient").find(".general-error-msg").removeClass("hideclass").addClass('showclass');
					}

					
                    _self.bookingformcommon.preloaderClose();

                }
            });
        });
    }

	handleGiftOptions():any{
		let _self=this;

		$("#mhgiftcard-redeem-options .option").click(function(){
			$("#mhgiftcard-redeem-options .option").removeClass("selected");
			$(this).addClass("selected");
			if($(this).text().toLowerCase()==="redeem for self"){
				$("#mhgiftcard-recipient").removeClass("showclass").addClass("hideclass");
			}
			else{
				$("#mhgiftcard-recipient").removeClass("hideclass").addClass("showclass");
			}
		});

		$(".mhgiftcard-li-items").click(function(){
			$(".mhgiftcard-li-items").removeClass("selected");
			$(this).addClass("selected");
			_self.occasion = $(this).find('span').text();
		})

	}
	handleTermsConditions():any{
		let _self=this;
			$('#redemption--miles-terms-and-conditions:checkbox').change(function(){
				if($('#redemption--miles-terms-and-conditions').is(':checked')){
					if(parseInt(_self.partnerRdmForm.find('#mhgiftcard--voucher-total').val())>0){
						$(".btn-member--submit").removeClass("disabled");
					}
			}
			else{
				$(".btn-member--submit").addClass("disabled");
			}
			})
		
	}
	initSubmitForm(){
		let _self = this;		
		$(".btn-member--submit").click(function () {
				_self.submissionAPI();
		});
	}
	submissionAPI():any{
		let defer = $.Deferred();
		let _self = this;
		let awardcode: any;
		let awardValue: any;
		let awardKey:any;
			if (_self.voucherList.length > 0) {
				awardcode = _self.selectedVoucher.AwardCode;
				awardValue = _self.selectedVoucher.AwardValue;
				awardKey = _self.selectedVoucher.AwardKey;
			}
			let initialBalance = _self.partnerRdmForm.find('#mhgiftcard-current-balance').text();
			let totalRedeemedMiles = _self.partnerRdmForm.find('#mhgiftcard--voucher-total').val();
			let discountAmount = _self.selectedDenomination;
			let discountAmountCount = _self.partnerRdmForm.find('#mhgiftcard-qty').text().trim();

			let shoppingcartId = $(".mhgiftcard-description input:hidden[name='shoppingCartID']").val();
			let redeemCampaignId = $(".mhgiftcard-description input:hidden[name='campaignId']").val();
			let redeempartner_code = $(".mhgiftcard-description input:hidden[id='partner_code']").val();
			let numberOfDays = $(".mhgiftcard-description input:hidden[id='numberOfDays']").val();
			let numberOfMonths = $(".mhgiftcard-description input:hidden[id='numberOfMonths']").val();
			let voucherCatg	  = $(".mhgiftcard-description input:hidden[name='voucherCategory']").val();
			let currencyValue	  = $(".mhgiftcard-description input:hidden[name='currencyValue']").val();

			_self.giftMessage = $("#mhgiftcard-gift-msg").val();
			_self.occasion = $("#mhgiftcard-occasion li.selected").data('occasion')||"";
			let redeemOption = $("#mhgiftcard-redeem-options .option.selected").data('redeemOption')||"";
			

			if (parseInt(totalRedeemedMiles) <= 0) {
				$(".successMsg").removeClass("showclass");
				$(".successMsg").addClass("hideclass");
				$(".errorMsg").removeClass("showclass");
				$(".errorMsg").addClass("hideclass");
				$(".onload_errorMsg").removeClass("showclass");
				$(".onload_errorMsg").addClass("hideclass");
				$(".redeem-mhgiftcard").removeClass("hideclass");
				$(".redeem-mhgiftcard").addClass("showclass");
				$(".overwhelming_resp").removeClass("showclass");
				$(".overwhelming_resp").addClass("hideclass");
				$(".maxcount_reached_onload").removeClass("showclass");
				$(".maxcount_reached_onload").addClass("hideclass");
				$(".maxcount_reached_onclick").removeClass("showclass");
				$(".maxcount_reached_onclick").addClass("hideclass");
				$(".voucherEligibity").removeClass("hideclass");
				$(".voucherEligibity").addClass("showclass");
				//$(".max4errorMsg").removeClass("showclass");
				//$(".max4errorMsg").addClass("hideclass");
			} else {
				
				var data = {
					'campaignID': redeemCampaignId,
					'partner_code': redeempartner_code,
					'shoppingcartId': shoppingcartId,
					'initialBalance': initialBalance,
					'discountAmount': discountAmount,
					'discountAmountCount': discountAmountCount,
					'awardcode': awardcode,
					'numberOfDays': numberOfDays,
					'numberOfMonths': numberOfMonths,
					'voucherCategory':voucherCatg,
					'awardValue' : awardValue,	
					'currencyValue': currencyValue,
					'redeem_option': redeemOption,
					'occasion': _self.occasion,
					'message': _self.giftMessage,
					'awardKey':awardKey

				};

				_self.bookingformcommon.preloader();
				let submiturl = '/bin/services/new/redeemVoucherMHGiftcard';


				$.ajax({
					type: 'POST',
					url: submiturl, 
					data: data,
					success: function (data: any) {
						//var json = JSON.parse(data);
						let json: any = null;
						if (typeof data === 'string') {
							json = JSON.parse(data);
						} else {
							json = data;
						}
						_self.bookingformcommon.preloaderClose();
						if (json.code == "OK") {

							let navMilesVal = json.currentBalance;
							$(".miles-value").text(numeral(navMilesVal).format('0,0'));
							document.cookie = "milesCount=" + navMilesVal + ";path=/";
							$(".successMsg").removeClass("hideclass");
							$(".successMsg").addClass("showclass");
							$("#newvoucher-partnerName").text(json.description);
							$(".errorMsg").removeClass("showclass");
							$(".errorMsg").addClass("hideclass");
							$(".onload_errorMsg").removeClass("showclass");
							$(".onload_errorMsg").addClass("hideclass");
							$(".redeem-mhgiftcard").removeClass("showclass");
							$(".redeem-mhgiftcard").addClass("hideclass");
							$(".voucherEligibity").removeClass("showclass");
							$(".voucherEligibity").addClass("hideclass");
							$(".overwhelming_resp").removeClass("showclass");
							$(".overwhelming_resp").addClass("hideclass");
							$(".maxcount_reached_onload").removeClass("showclass");
							$(".maxcount_reached_onload").addClass("hideclass");
							$(".maxcount_reached_onclick").removeClass("showclass");
							$(".maxcount_reached_onclick").addClass("hideclass");

							$(".rmMaxErrorMsg4").removeClass("showclass");
							$(".rmMaxErrorMsg4").addClass("hideclass");
						} else {

							$('.errMsg').text(json.message);
							$(".redeem-mhgiftcard").removeClass("showclass");
							$(".redeem-mhgiftcard").addClass("hideclass");
							$(".successMsg").removeClass("showclass");
							$(".successMsg").addClass("hideclass");
							$(".errorMsg").removeClass("hideclass");
							$(".errorMsg").addClass("showclass");
							$(".voucherEligibity").removeClass("showclass");
							$(".voucherEligibity").addClass("hideclass");
							$(".overwhelming_resp").removeClass("showclass");
							$(".overwhelming_resp").addClass("hideclass");
							$(".maxcount_reached_onload").removeClass("showclass");
							$(".maxcount_reached_onload").addClass("hideclass");
							$(".maxcount_reached_onclick").removeClass("showclass");
							$(".maxcount_reached_onclick").addClass("hideclass");

							$(".rmMaxErrorMsg4").removeClass("showclass");
							$(".rmMaxErrorMsg4").addClass("hideclass");
						}

					}, error: function (error: any) {
						defer.reject(error);
						_self.bookingformcommon.preloaderClose();
					}
				});
				return defer.promise();
			}
	}
	getCookie(name: string): any {
		var value = "; " + document.cookie;
		var parts = value.split("; " + name + "=");
		var cookieVal: any;
		if (parts.length == 2) {
			cookieVal = parts.pop().split(";").shift();
			return cookieVal;
		}
	}

}
function parseJwt(token: any): any {
	var base64Url = token.split('.')[1];
	var base64 = decodeURIComponent(atob(base64Url).split('').map(function (c) {
		return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
	}).join(''));

	return JSON.parse(base64);
};
/**
		 * common function to set incrementer value/display for click/hold events
		 * @param  {any}    elDisplay [description]
		 * @param  {any}    input     [description]
		 * @param  {any}    curVal    [description]
		 * @param  {any}    params    [description]
		 * @param  {string} type      [description]
		 * @return {any}              [description]
		 */

function setIncrementer(elDisplay: any, input: any, curVal: any, params: any, type: string,): any {
	if (type == 'decrement') {
		if (curVal > params.min) {
			curVal--;
		}
	}

	if (type == 'increment') {
		if (curVal < params.max) {
			curVal++;
		}
	}
	if (curVal <= params.min){

		$("#mhgiftcard-qty--decrement").addClass("disabled");

	}
	else{

		$("#mhgiftcard-qty--decrement").removeClass("disabled");

	}
	//alert("assign-curVal>>"+curVal);

	elDisplay.html(curVal);
	input.val(curVal);

	input.parent().trigger('incrementer.changed', [curVal]);
	return curVal;
}
let scope: Element = document.querySelector('.members--redeem--mhgiftcard #mhgiftcard-redeem-form');

if (scope) {
	try {
		let mhgiftcard = new memberRedeemMHgiftcard();
		var adobeDataLayer = new adobeDataLayerWrapper();
		adobeDataLayer.push('pageLoaded', {
            'pageName': '',
            'pageType': 'Enrich Redemption Page - Gift Cards - Product Page',
			'attributes': []
        });
		mhgiftcard.initMhInputs();
		mhgiftcard.initVouchersAndUsers();
		mhgiftcard.handleIncrement()
		mhgiftcard.handleGiftOptions();
		mhgiftcard.checkEnrichId();
		mhgiftcard.handleTermsConditions();
		mhgiftcard.initSubmitForm();

	} catch (e) { console.error(e); }
}

